import { Component, OnChanges, EventEmitter, Input, Output } from '@angular/core';

export interface IFilterOption {
  value: any;
  displayText: string;
  class: string;
}

// TODO: Refactorizar haciendo obligatorio el uso del tagID? O crear otro modelo distinto para expansor-multiple
export interface ISelectedValue {
  value: any;
  categoryName: string;
  viewValue: any;
  tagID?: number;
}

@Component({
  selector: 'app-expansor-with-search',
  templateUrl: './expansor-with-search.component.html',
  styleUrls: ['./expansor-with-search.component.scss']
})
export class ExpansorWithSearchComponent implements OnChanges {

  @Input() expanded = false;
  @Input() hideDivider = false;
  @Input() placeHolderText = '';
  @Input() categoryName = '';
  @Output() filterChangeEvent = new EventEmitter<ISelectedValue>();
  filterValue: IFilterOption = {value: '', displayText: '', class: ''};

  @Input() set selectedValue(value: any) {
    if (value !== undefined) {
      // Es necesario un timeout de 0 para que se cierre el ciclo y el componente exista como view children en el padre
      setTimeout(() => this.onFilterChange(value), 0);
    }
  }

  showChip = false;
  selectedTextValue = '';

  constructor() {}

  ngOnChanges() {
  }

  onFilterChange(selectedValue: any) {

  }

  onRemoveChip() {
    this.showChip = false;
  }

  apply() {
    this.showChip = true;
    this.filterChangeEvent.emit({
      value: this.filterValue.displayText, categoryName: this.categoryName, viewValue: this.filterValue.displayText});
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/expansor-with-search/expansor-with-search.component.ts